import {
  action,
  set,
  remove,
  computed,
  observable,
  makeObservable
} from 'mobx';
import axios from '../lib/axios';
import agent from '../lib/agent';
import { groupBy } from '../lib/utils';

class Store {
  project = null;
  members = [];
  projects = new Map();
  totalResults = 0;
  resultMap = new Map();

  filters = {
    name: ''
  };

  removeProject = id => {
    this.projects.delete(id);
    const resultMap = new Map(this.resultMap);
    resultMap.delete(id);
    this.resultMap = resultMap;
    // console.log(JSON.stringify(resultMap.size));
  };

  loadProject = async id => {
    try {
      const { data } = await agent.Project.getProject(id);

      const hasAccess = data.data.has_access;
      if (typeof hasAccess !== 'undefined' && hasAccess === false) {
        this.removeProject(id);
        return null;
      }

      if (data.data) {
        this.projects.set(data.data.id, data.data);
        return this.projects.get(id);
      }
    } catch (err) {
      this.removeProject(id);

      return null;
    }
  };

  constructor() {
    makeObservable(this, {
      project: observable,
      members: observable,
      projects: observable,
      totalResults: observable,
      resultMap: observable,
      filters: observable,
      loadProject: action,
      groupedProjectsByTerm: computed,
      setFilter: action,
      get: action,
      setResults: action,
      fetchAll: action,
      deleteProject: action,
      getProjectBuilding: action,
      deleteProjectBuilding: action,
      updateProjectBuildingGeometry: action,
      updateProjectBuilding: action,
      createProjectBuilding: action,
      updateProject: action,
      setMembers: action,
      getProjectBuildingFeature: action,
      createProject: action
    });
  }

  get groupedProjectsByTerm() {
    const projects = [...this.resultMap.values()].filter(project => {
      if (!this.filters.name) return true;
      return new RegExp(this.filters.name, 'i').test(project.name);
    });

    const groupedProjects = groupBy(projects, 'status');

    return groupedProjects;
  }

  setFilter = (name, value) => {
    if (value === null) {
      remove(this.filters, name, value);
      return;
    }
    set(this.filters, name, value);
  };

  get = id => {
    return this.projects.get(id);
  };

  setResults(results) {
    this.resultMap = results;
  }

  fetchAll = async () => {
    const { data } = await agent.Project.getProjects();
    const arr = data.data.map(result => {
      return [result.id, result];
    });

    this.resultMap = new Map(arr);
  };

  deleteProject = async id => {
    const { data } = await agent.Project.deleteProject(id);
    const currentResults = new Map(this.resultMap);
    currentResults.delete(id);
    this.resultMap = currentResults;

    return data.data;
  };

  getProjectBuilding = async (projectId, buildingId) => {
    const { data } = await agent.Project.getProjectBuilding(
      projectId,
      buildingId
    );
    return data.data;
  };

  deleteProjectBuilding = async (projectId, buildingId) => {
    // const currentResults = new Map(this.resultMap);
    // const project = currentResults.get(projectId);
    // project.buildings = project.buildings.filter(b => b.id !== buildingId);
    // currentResults.set(project.id, project);
    // this.resultMap = currentResults;

    const { data } = await agent.Project.removeBuilding(projectId, [
      {
        id: buildingId
      }
    ]);

    return data;
  };

  updateProjectBuildingGeometry = async (projectId, buildingId, geometry) => {
    agent.Project.updateProjectBuildingGeometry(
      projectId,
      buildingId,
      geometry
    );
  };

  updateProjectBuilding = async (projectId, buildingData) => {
    const { data } = await agent.Project.updateProjectBuilding(
      projectId,
      buildingData.id,
      buildingData
    );
    return data.data;
  };

  createProjectBuilding = async (projectId, buildingData) => {
    const { data } = await agent.Project.createBuilding(
      projectId,
      buildingData
    );
    return data.data;
  };

  updateProject = async (id, params) => {
    const { data } = await axios.patch(`/project/${id}`, params);
    const project = this.resultMap.get(id);
    if (project) {
      const resultMap = new Map(this.resultMap);

      resultMap.set(id, {
        ...project,
        name: data.data.name,
        color: data.data.color
      });

      this.resultMap = resultMap;
    }
  };

  setMembers = async members => {
    this.members = members;
  };

  getProjectBuildingFeature = async (projectId, buildingId) => {
    const { data } = await axios.get(
      `/project/${projectId}/building/${buildingId}/feature`
    );
    // this.projectBuildingRegistry.set(data.data.id, formattedData);
    return data;
  };

  createProject = async params => {
    const { data } = await agent.Project.createProject(params);
    if (data.ok) return data.data;
  };
}

const store = new Store();
export default store;
